import downArrow from "../assets/icons/down_arrow.svg";
import search from "../assets/icons/search.svg";
import menuList from "../assets/icons/menu_list.svg";
import back from "../assets/icons/back.svg";
import bell from "../assets/icons/bell.svg";
import downArrowYellow from "../assets/icons/down_arrow_yellow.svg";
import downArrowWhite from "../assets/icons/down_arrow_white.svg";
import person from "../assets/icons/person.svg";
import state from "../assets/icons/state.svg";
import stateSelected from "../assets/icons/state_selected.svg";
import selectedBell from "../assets/icons/selected_bell.svg";
import selectedPerson from "../assets/icons/selected_person.svg";
import selectedState from "../assets/icons/selected_states.svg";
import dropdownArrow from "../assets/icons/dropdown_arrow.svg";
import openLink from "../assets/icons/open_link.svg";
import home from "../assets/icons/home.svg";
import homeSelected from "../assets/icons/home_selected.svg";
import pieChart from "../assets/icons/pie_chart.svg";
import pieChartSelected from "../assets/icons/pie_chart_selected.svg";
import bag from "../assets/icons/bag.svg";
import bagSelected from "../assets/icons/bag_selected.svg";
import upArrowSelected from "../assets/icons/up_arrow_selected.svg";
import plus from "../assets/icons/plus.svg";
import plus_primary from "../assets/icons/plus_primary.svg";
import plusSelected from "../assets/icons/plus_selected.svg";
import download from "../assets/icons/download.svg";
import downloadSelected from "../assets/icons/download_selected.svg";
import roundArrow from "../assets/icons/round_arrow.svg";
import roundArrowSelected from "../assets/icons/round_arrow_selected.svg";
import slip from "../assets/icons/slip.svg";
import slipSelected from "../assets/icons/slip_selected.svg";
import cross from "../assets/icons/cross.svg";
import rightArow from "../assets/icons/right_arrow.svg";
import settings from "../assets/icons/settings.svg";
import dots from "../assets/icons/dots.svg";
import modalCross from "../assets/icons/modal_cross.svg";
import edit from "../assets/icons/edit.svg";
import investment from "../assets/icons/investment.svg";
import selectedInvestment from "../assets/icons/selected_investment.svg";
import statement from "../assets/icons/statement.svg";
import selectedStatement from "../assets/icons/selected_statement.svg";
import pdf from "../assets/icons/pdf.svg";
import tableCross from "../assets/icons/table_cross.svg";
import twoPerson from "../assets/icons/two_person.svg";
import twoPersonSelected from "../assets/icons/two_person_selected.svg";
import monitorGraph from "../assets/icons/monitor_graph.svg";
import monitorGraphSelected from "../assets/icons/monitor_graph_selected.svg";
import ordersList from "../assets/icons/order_list.svg";
import orderListSelected from "../assets/icons/order_list_selected.svg";
import letterT from "../assets/icons/letter_t.svg";
import letterTSelected from "../assets/icons/letter_t_selected.svg";
import filter from "../assets/icons/filter.svg";
import down from "../assets/icons/down.svg";
import up from "../assets/icons/up.svg";
import smallScreen from "../assets/icons/small_screen.svg";
import enterFullScreen from "../assets/icons/enter_full_screen.svg";
import tick from "../assets/icons/tick.svg";
import play from "../assets/icons/play.svg";
import delete_icon from "../assets/icons/delete.svg";
import delete_red from "../assets/icons/delete_red.svg";
import delete_big_red from "../assets/icons/delete_big_red.svg";
import delete_white_icon from "../assets/icons/delete_white_icon.svg";
import lossArrow from "../assets/icons/loss_arrow.svg";
import profitArrow from "../assets/icons/profit_arrow.svg";
import minus from "../assets/icons/minus.svg";
import rightAngle from "../assets/icons/right_angle.svg";
import calculator from "../assets/icons/calculator.svg";
import selectedComment from "../assets/icons/selected_comment.svg";
import comment from "../assets/icons/comment.svg";
import upwardArrow from "../assets/icons/upward_arrow.svg";
import downwardArrow from "../assets/icons/downward_arrow.svg";
import notifications from "../assets/icons/notifications.svg";
import cloud from "../assets/icons/cloud.svg";
import warning from "../assets/icons/warning.svg";
import success from "../assets/icons/success.svg";
import showPassword from "../assets/icons/show_password.svg";
import hidePassword from "../assets/icons/hide_password.svg";
import check from "../assets/icons/check_icon.svg";
import building from "../assets/icons/building.svg";
import info from "../assets/icons/info.svg";
import mobile from "../assets/icons/mobile.svg";
import person_check from "../assets/icons/person_check.svg";
import success_check from "../assets/icons/success_check.svg";
import pdf_icon from "../assets/icons/pdf_icon.svg";
import copy_icon from "../assets/icons/copy.svg";
import top_up from "../assets/icons/top_up.svg";
import link from "../assets/icons/link.svg";
import slide_arrow_icon from "../assets/icons/slide_arrow_icon.svg";
import view_icon from "../assets/icons/view_icon.svg";
import download_icon from "../assets/icons/download_icon.svg";
import eye_icon from "../assets/icons/eye_icon.svg";
import cash_icon from "../assets/icons/cash_icon.svg";
import reserved_icon from "../assets/icons/reserved_icon.svg";
import trash_icon from "../assets/icons/trash_icon.svg";
import logout_icon from "../assets/icons/logout_icon.svg";
import subscribeSelected from "../assets/icons/subscribe_selected.svg";
import subscribe from "../assets/icons/subscribe.svg";
import redeemSelected from "../assets/icons/redeem_selected.svg";
import redeem from "../assets/icons/redeem.svg";
import transactionsSelected from "../assets/icons/transactions_selected.svg";
import transactions from "../assets/icons/transactions.svg";
import generalSettingSelected from "../assets/icons/general_setting_selected.svg";
import generalSetting from "../assets/icons/general_setting.svg";
import transferSelected from "../assets/icons/transfer_selected.svg";
import transfer from "../assets/icons/transfer.svg";
import beneficierySelected from "../assets/icons/beneficiery_selected.svg";
import beneficiery from "../assets/icons/beneficiery.svg";
import lange from "../assets/icons/lange_icon.svg";
import passwordValidation from "../assets/icons/password_validation_icon.svg";
import edit_icon from "../assets/icons/edit_icon.svg";
import success_icon from "../assets/icons/success_icon.svg";
import null_icon from "../assets/icons/null_icon.svg";
import internalUnitExchange from "../assets/icons/internal-unit-exchange-icon.svg";
import internalUnitExchangeSelected from "../assets/icons/internal-unit-exchange-selected-icon.svg";
import buyUnitsBtn from "../assets/icons/buy_units_icon.svg";
import sellUnitsBtn from "../assets/icons/sell_units_icon.svg";
import viewActionbtn from "../assets/icons/view_action_icon.svg";
import backSmall from "../assets/icons/back_small_Icon.svg";
import backSmallWhite from "../assets/icons/back_small_white_Icon.svg";
import document_icon from "../assets/icons/document_icon.svg";
import close_icon from "../assets/icons/close_icon.svg";
import faq_plus_icon from "../assets/icons/faq_plus_icon.svg";
import Faqs_minus_icon from "../assets/icons/faq_minus_icon.svg";
import Faqs_icon from "../assets/icons/faqs_icon.svg";
import Faqs_black_icon from "../assets/icons/faqs_black_icon.svg";
import fundReports_icon from "../assets/icons/fundReports_icon.svg";
import fundReportsSelected_icon from "../assets/icons/fundReports_active_icon.svg";
import backVerySm_icon from "../assets/icons/back_very_sm_icon.svg";
import myFund from "../assets/icons/my_fund_icon.svg";
import myFundSelected from "../assets/icons/my_fund_selected_icon.svg";
import addTopupIcon from "../assets/icons/add_topup_icon.svg";
import addTopupIconSelected from "../assets/icons/add_topup_icon_selected.svg";
import rightArrowIcon from "../assets/icons/right_arrow_icon.svg";
import leftArrowIcon from "../assets/icons/left_arrow_icon.svg";
import BlackDownArrowIcon from "../assets/icons/down_arrow_black.svg";
import BlackLangeIcon from "../assets/icons/black_lange_icon.svg";
import mouseIcon from "../assets/icons/mouse_icon.svg";
import editIcon from "../assets/icons/setting_edit_icon.svg";
import tickCircleIcon from "../assets/icons/tick_circle_icon.svg";
import greenTickIcon from "../assets/icons/tick-circle_icon.svg";

const icons = {
  leftArrowIcon,
  rightArrowIcon,
  downArrow,
  search,
  menuList,
  back,
  bell,
  downArrowWhite,
  downArrowYellow,
  person,
  state,
  selectedBell,
  selectedPerson,
  selectedState,
  dropdownArrow,
  openLink,
  home,
  homeSelected,
  pieChart,
  pieChartSelected,
  bag,
  bagSelected,
  upArrowSelected,
  plus,
  plus_primary,
  plusSelected,
  download,
  downloadSelected,
  roundArrow,
  roundArrowSelected,
  slip,
  slipSelected,
  cross,
  rightArow,
  settings,
  dots,
  modalCross,
  edit,
  investment,
  selectedInvestment,
  statement,
  selectedStatement,
  pdf,
  tableCross,
  stateSelected,
  twoPerson,
  twoPersonSelected,
  monitorGraph,
  monitorGraphSelected,
  ordersList,
  orderListSelected,
  letterT,
  letterTSelected,
  filter,
  down,
  up,
  smallScreen,
  enterFullScreen,
  tick,
  play,
  delete_icon,
  delete_red,
  delete_big_red,
  delete_white_icon,
  lossArrow,
  profitArrow,
  minus,
  rightAngle,
  calculator,
  selectedComment,
  comment,
  upwardArrow,
  downwardArrow,
  notifications,
  cloud,
  warning,
  success,
  showPassword,
  hidePassword,
  check,
  building,
  info,
  mobile,
  person_check,
  success_check,
  pdf_icon,
  copy_icon,
  top_up,
  link,
  slide_arrow_icon,
  view_icon,
  download_icon,
  eye_icon,
  cash_icon,
  reserved_icon,
  trash_icon,
  logout_icon,
  subscribeSelected,
  subscribe,
  redeemSelected,
  redeem,
  transactionsSelected,
  transactions,
  generalSettingSelected,
  generalSetting,
  transferSelected,
  transfer,
  beneficierySelected,
  beneficiery,
  lange,
  passwordValidation,
  edit_icon,
  success_icon,
  null_icon,
  internalUnitExchange,
  internalUnitExchangeSelected,
  buyUnitsBtn,
  sellUnitsBtn,
  viewActionbtn,
  backSmall,
  backSmallWhite,
  document_icon,
  close_icon,
  faq_plus_icon,
  Faqs_minus_icon,
  Faqs_icon,
  Faqs_black_icon,
  fundReports_icon,
  fundReportsSelected_icon,
  backVerySm_icon,
  myFund,
  myFundSelected,
  addTopupIcon,
  addTopupIconSelected,
  BlackDownArrowIcon,
  BlackLangeIcon,
  mouseIcon,
  editIcon,
  tickCircleIcon,
  greenTickIcon,
};

export default icons;
